var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"utterancesContainer"})
}
var staticRenderFns = []

export { render, staticRenderFns }